import React from 'react'
import { motion } from "framer-motion"

const Photo = ({ onPhoto }) => {
    
    return (
        <div className="relative flex justify-center items-center">
            <motion.div 
                initial={{opacity:0}}
                animate ={{
                    opacity:1,
                    transition: { delay:2, duration:0.4, ease:"easeIn" }
                }}
                className="relative flex justify-center items-center w-[300px] h-[300px] xl:w-[500px] xl:h-[500px] rounded-full overflow-hidden"
            >
                {/* Profile Image */}
                {onPhoto ? (
                    <motion.img
                        src={onPhoto}
                        alt="Danial Islam"
                        className="w-full h-full object-cover"
                        style={{
                            clipPath: "circle(50%)", // Ensure circular cropping
                        }}
                        initial={{ scale: 1 }}
                        animate={{ scale: 1.1 }}
                        transition={{
                            duration: 5,
                            repeat: Infinity,
                            repeatType: "reverse"
                        }}
                    />
                ) : (
                    <div className="flex justify-center items-center w-full h-full bg-gray-200">
                        No Image Available
                    </div>
                )}
            </motion.div>

            {/* Rotating Circle Animation */}
            <motion.svg 
                className="absolute w-[320px] h-[320px] xl:w-[520px] xl:h-[520px]"
                fill="transparent"
                viewBox="0 0 506 506"
                xmlns="http://www.w3.org/2000/svg"
            >
                <motion.circle 
                    cx="253" 
                    cy="253" 
                    r="250" 
                    stroke="#00ff99" 
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    initial={{ strokeDasharray: "24 10 0 0" }}
                    animate={{
                        strokeDasharray: ["15 120 25 25", "16 25 92 72", "4 250 22 22"],
                        rotate: [120, 360]
                    }}
                    transition={{
                        duration: 20,
                        repeat: Infinity,
                        repeatType: "reverse"
                    }}
                />
            </motion.svg>
        </div>
    )
}

export default Photo;
